interface Instance {
  rows: number
  url: string
  sopInstanceUid?: string
}

interface Series {
  seriesInstanceUid: string
  instances: Instance[]
}

export interface Study {
  studyInstanceUid?: string
  seriesList?: Series[]
  isNifti?: boolean
  baseURL?: string
}

const baseStudy: Partial<Study> = {
  studyInstanceUid: 'AnyStudyInstanceUid',
  seriesList: [],
};

export function createNiftiStudy(image: string): Study {
  return {
    ...baseStudy,
    isNifti: true,
    baseURL: `nifti://${window.location.host}${image}`,
  };
}

export function createImageStudy(images: string[]): Study {
  return {
    ...baseStudy,
    seriesList: [{
      seriesInstanceUid: 'AnySeriesInstanceUid',
      instances: images.map((image) => {
        const imageUrl = `https://${window.location.host}${image}`;
        return {
          rows: 1,
          url: imageUrl,
          sopInstanceUid: imageUrl,
        };
      }),
    }],
  };
}

export function createDicomStudy(images: string[]): Study {
  return {
    ...baseStudy,
    seriesList: [{
      seriesInstanceUid: 'AnySeriesInstanceUid',
      instances: images.sort().map((image) => {
        return {
          rows: 1, // necessary otherwise instance is not treated as an image
          url: `dicomweb://${window.location.host}${image}`,
        };
      }),
    }],
  };
}
